const ActionTypeEnum = Object.freeze({
  CALCULATE: 1,
  UPDATE_WITHOUT_CALCULATION: 2,
});

export default (ActionTypeEnum);
